import {bigdataRequest} from './axios'
import qs from 'qs';

let bastUrl = '/bigdata';
/**
 *
 *
 */
export default {
  /**
   * 获取商品列表
   */
  commodityList(data) {
    return bigdataRequest.get(bastUrl + '/api/commodityMgmt/list', {
      params: data
    });
  },
  getShopList(data){
    return bigdataRequest.get(bastUrl + '/api/commodityMgmt/amazonShops', {
      params: data
    });
  },

}
